module.exports = __webpack_public_path__ + "media/stitches.f00372f3.wav";